import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createCredencialRdp } from '../../helpers/api_helper';

const useCreateCredencialRdp = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const createCredencialRdpHook = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createCredencialRdp(tenantId, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to create Credencial RDP: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { createCredencialRdp: createCredencialRdpHook, loading, error };
};

export default useCreateCredencialRdp;
